import React, { useState, useRef, useEffect } from "react";
import {
  FaPhone,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaUserShield,
  FaCamera,
  FaSignOutAlt,
  FaEdit,
  FaSave,
  FaTimes,
} from "react-icons/fa";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getMe, updateUser } from "../services/authService";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/user/Profile.css";

export default function Profile() {
  const [user, setUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const fileInputRef = useRef(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false); 


  
  useEffect(() => {
  const checkLoginStatus = () => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);  // Cập nhật trạng thái đăng nhập
  };

  checkLoginStatus();
  window.addEventListener("storage", checkLoginStatus);

  return () => window.removeEventListener("storage", checkLoginStatus);
}, []);


  // Lấy thông tin người dùng từ localStorage (sử dụng getMe API để cập nhật)
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const me = await getMe();
        setUser(me);
        setFormData(me);
      } catch {
        toast.error("⚠️ Không thể tải thông tin người dùng!");
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Xử lý thay đổi input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Đổi ảnh đại diện
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () =>
        setFormData((prev) => ({ ...prev, avatar: reader.result }));
      reader.readAsDataURL(file);
    }
  };

  // Lưu chỉnh sửa
  const handleSave = async () => {
    try {
      const updated = await updateUser(formData);
      setUser(updated);
      setFormData(updated);
      setEditMode(false);
      toast.success("✅ Cập nhật thành công!");
    } catch {
      toast.error("❌ Cập nhật thất bại!");
    }
  };

  // Đăng xuất
  const handleLogout = () => {
    toast(
      ({ closeToast }) => (
        <motion.div
          initial={{ opacity: 0, y: -10, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.3 }}
          className="logout-toast"
        >
          <h4>🔒 Xác nhận đăng xuất?</h4>
          <div className="toast-buttons">
            <button className="cancel-btn" onClick={closeToast}>
              Hủy
            </button>
            <button
              className="confirm-btn"
              onClick={() => {
                closeToast();
                performLogout();
              }}
            >
              Đăng xuất
            </button>
          </div>
        </motion.div>
      ),
      {
        position: "top-right",
        autoClose: false,
        hideProgressBar: true,
        draggable: false,
        closeButton: false,
        className: "custom-toast",
      }
    );
  };

const performLogout = () => {
  toast.success("👋 Đăng xuất thành công!", {
    position: "top-right",
    autoClose: 1500,
  });

  setTimeout(() => {
    // Xóa thông tin người dùng và token khỏi localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    // Cập nhật lại trạng thái đăng nhập
    setIsLoggedIn(false);  // Đảm bảo trạng thái đăng nhập được cập nhật sau khi đăng xuất

    // Chuyển hướng về trang chủ hoặc trang login
    window.location.replace("/");  // Chuyển hướng về trang chủ
    window.location.reload(); // Reload trang sau khi chuyển hướng
  }, 1500);
};

  if (!user)
    return (
      <div style={{ paddingTop: 80 }}>
        <Header />
        <p style={{ textAlign: "center", padding: 60 }}>⏳ Đang tải thông tin...</p>
        <Footer />
      </div>
    );

  return (
    <div className="profile-page">
      <Header />
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="profile-container"
      >
        {/* ẢNH ĐẠI DIỆN */}
        <motion.div
          whileHover={{ scale: 1.08 }}
          transition={{ duration: 0.3 }}
          className="avatar-box"
        >
          <img
            src={formData.avatar || "/user.png"}
            alt="avatar"
            className="avatar"
          />
          <motion.button
            whileHover={{ rotate: 20 }}
            whileTap={{ scale: 0.9 }}
            className="camera-btn"
            onClick={() => fileInputRef.current.click()}
          >
            <FaCamera />
          </motion.button>
          <input
            type="file"
            ref={fileInputRef}
            accept="image/*"
            style={{ display: "none" }}
            onChange={handleAvatarChange}
          />
        </motion.div>

        {/* THÔNG TIN */}
        <h2 className="name">{user.name || "Chưa có tên"}</h2>
        <p className="email">{user.email}</p>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
          className="info-card"
        >
          {editMode ? (
            <>
              {["name", "email", "phone", "address"].map((field, idx) => (
                <motion.input
                  key={idx}
                  name={field}
                  value={formData[field] || ""}
                  onChange={handleChange}
                  placeholder={
                    field === "name"
                      ? "Họ tên"
                      : field === "email"
                      ? "Email"
                      : field === "phone"
                      ? "Số điện thoại"
                      : "Địa chỉ"
                  }
                  whileFocus={{ scale: 1.02 }}
                  className="input-field"
                />
              ))}
              <div className="action-row">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  onClick={handleSave}
                  className="save-btn"
                >
                  <FaSave /> Lưu
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  onClick={() => {
                    setEditMode(false);
                    setFormData(user);
                  }}
                  className="cancel-btn"
                >
                  <FaTimes /> Hủy
                </motion.button>
              </div>
            </>
          ) : (
            <>
              <p className="item">
                <FaPhone className="icon" /> {user.phone || "Chưa cập nhật"}
              </p>
              <p className="item">
                <FaMapMarkerAlt className="icon" />{" "}
                {user.address || "Chưa cập nhật địa chỉ"}
              </p>
              <p className="item">
                <FaCalendarAlt className="icon" />{" "}
                {user.createdAt
                  ? new Date(user.createdAt).toLocaleDateString("vi-VN")
                  : "Không rõ"}
              </p>
              <p className="item">
                <FaUserShield className="icon" /> Vai trò:{" "}
                {user.role === "CTV" ? "Cộng tác viên" : user.role || "Người dùng"}
              </p>

              {/* 2 NÚT HÀNH ĐỘNG */}
              <div className="two-btn-row">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  onClick={() => setEditMode(true)}
                  className="edit-btn"
                >
                  <FaEdit /> Chỉnh sửa
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  onClick={handleLogout}
                  className="logout-btn"
                >
                  <FaSignOutAlt /> Đăng xuất
                </motion.button>
              </div>
            </>
          )}
        </motion.div>
      </motion.div>

      <Footer />
      <ToastContainer position="top-right" />
    </div>
  );
}
